<Tabs tabs={assignToTabs} bind:selectedIndex={selectedTabIndex}>
    <AssignToModalParticipantsTab {isFirstLoad} {participants} />
    <AssignToModalGroupsTab {groups}/>
</Tabs>

<script>
    import Tabs from "@itslearning/prometheus/assets/Navigation/Tabs/v1/Tabs.svelte";
    import i18n from "@its-ui/planner-common/i18n";
    import AssignToModalGroupsTab from "./Groups/AssignToModalGroupsTab.svelte";
    import AssignToModalParticipantsTab from "./Participants/AssignToModalParticipantsTab.svelte";

    const assignToTabs = [
        { id: "participantsTab", target: "#participantsSection", title: i18n.participants },
        { id: "groupsTab", target: "#groupsSection", title: i18n.groups },
    ];
    let selectedTabIndex = 0;

    export let participants;
    export let groups;
    export let isFirstLoad = false;
</script>
